export default class LightOak {
    constructor() {
        this.number = 5;
        this.label = 'Mørk eg ramme';
        this.image_name = 'dark-oak';
        this.id = 'frame-' + this.image_name;
        this.path = '/wp-content/themes/orchid-store-kc/assets/dist/img/frame/';
        this.extension = '.png';
        this.src =  this.path + this.image_name + this.extension;
        this.paperOuterPadding = 0;
        this.addFrameShadow = false;
        this.frameCount = 1;
    }
}
